module.exports = __webpack_public_path__ + "img/about-bg.c51f0220.png";